/**
 * @file スタイル設定：font-family 定数管理
 */

export const fontFamily = {
    mediaPlayer: '"Segoe UI"',
    icon: '"Font Awesome 5 Free"',
};
